document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bycs-buildbox]').forEach((root) => {
    const steps = [...root.querySelectorAll('[data-step]')];
    const slots = [...root.querySelectorAll('[data-slot]')];
    const inputs = [...root.querySelectorAll('input[data-property]')];
    const next = root.querySelector('[data-next]');
    const back = root.querySelector('[data-back]');
    const add = root.querySelector('[data-add]');
    const oneEach = root.querySelector('[data-one-each]');
    const message = root.querySelector('[data-message]');
    const summary = root.querySelector('[data-summary]');
    let current = 0;
    const selections = ['', '', '', ''];
    const flavors = ['OG Chocolate Sea Salt','Pistachio Strawberry','Bourbon Caramel Pecan','Gingerbread Cookie'];

    const paint = () => {
      steps.forEach((s,i) => s.classList.toggle('is-current', i === current));
      slots.forEach((slot,i) => {
        const text = slot.querySelector('span');
        text.textContent = selections[i] || 'Choose a flavor';
      });
      inputs.forEach((input,i) => input.value = selections[i]);
      root.querySelectorAll('[data-choice]').forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.choice === selections[current]);
      });
      if (back) back.disabled = current === 0;
      if (next) next.hidden = current === 3;
      if (add) add.hidden = current !== 3;
      const complete = selections.every(Boolean);
      if (add) add.disabled = !complete;
      const counts = {};
      selections.filter(Boolean).forEach(x => counts[x] = (counts[x] || 0) + 1);
      summary.textContent = Object.entries(counts).map(([k,v]) => `${k} × ${v}`).join(' · ') || 'Choose four pieces — repeats are welcome.';
      message.textContent = complete ? 'Your four-piece box is ready to add to cart.' : `Choose piece ${current + 1}.`;
    };

    root.querySelectorAll('[data-choice]').forEach(btn => btn.addEventListener('click', () => {
      selections[current] = btn.dataset.choice;
      paint();
    }));
    if (next) next.addEventListener('click', () => {
      if (!selections[current]) { message.textContent = 'Choose a flavor before continuing.'; return; }
      current = Math.min(3, current + 1); paint();
    });
    if (back) back.addEventListener('click', () => { current = Math.max(0, current - 1); paint(); });
    if (oneEach) oneEach.addEventListener('click', () => { flavors.forEach((f,i) => selections[i] = f); current = 3; paint(); });
    root.addEventListener('submit', (e) => {
      if (!selections.every(Boolean)) { e.preventDefault(); message.textContent = 'Choose all four pieces before adding your box.'; }
    });
    paint();
  });
});
